import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import moment from "moment";


export default function CheckDate({ label, value, onChange }){

    const handleClick = () => {

        if(value){

            const clearConfirm = window.confirm("Êtes vous sûr de vouloir effacer cette date ?");

            return clearConfirm ? onChange(null) : false;
        }

        const defaultValue = ( value ? moment(value) : moment() ).format('DD/MM/YYYY');

        const day = window.prompt(label || "Date :", defaultValue);

        if(day === null) return false;

        if(day === '') return onChange(null);

        const pattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;

        if( !pattern.test(day) ) return window.alert("Date incorrecte.");

        const d = day.split('/');

        const dateStr = `${d[2]}-${d[1]}-${d[0]}`;

        return onChange(dateStr);
    }

    return (

        <FormControlLabel
            label={
                <Typography variant="body2" color="text.secondary">
                    {value ? moment(value).format('DD/MM/YYYY') : ''}
                </Typography>
            }
            control={
                <Checkbox 
                    size="small"
                    checked={value ? true : false}
                    onChange={handleClick}
                />
            }
        />
    )
}